import { InputHTMLAttributes } from "react";
const CustomSwitch = (props: InputHTMLAttributes<HTMLInputElement>) => {
  return <label className='ws-switch -mr-1.5 scale-75' data-sentry-component="CustomSwitch" data-sentry-source-file="CustomSwitch.tsx">
      <input type='checkbox' {...props} />
      <span className='ws-slider'>
        <span className='ws-slider-thumb flex items-center justify-center'>
          {/* This span is for switch's circle */}
        </span>
      </span>
    </label>;
};
export default CustomSwitch;